import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { BoxProps } from '@dtx-company/shared-components/src'
import { Flowcode } from '@dtx-company/flowcode-generator-browser/src'
import { Spacer } from '@dtx-company/shared-components/src/components/atoms/Spacer/index'
import { Text } from '@dtx-company/shared-components/src/components/atoms/Text/index'
import { useCreateFlowcodeState } from '../../../../../hooks/useCreateFlowcodeState'
import React from 'react'

export const SimplifiedCodePreview: React.FC<{ title?: string } & BoxProps> = ({
  title,
  ...props
}) => {
  const { options: flowcodeOptions } = useCreateFlowcodeState()
  return (
    <Box flexDirection={'column'} alignItems="center">
      {title && (
        <>
          <Spacer mt="8px" />
          <Text variant={'display/small'} textAlign="center">
            {title}
          </Text>
          <Spacer mb="15px" />
        </>
      )}
      <Box width={'200px'} height="200px" data-testid="flowcode-container" {...props}>
        <Flowcode options={flowcodeOptions} />
      </Box>
    </Box>
  )
}
